import { h, Fragment } from 'preact';
import clsx from 'clsx';

const CartLineAttributes = ({ line }) => {
  const attributes =
    line.attributes ||
    Object.entries(line.properties || {}).map(([key, value]) => ({
      key,
      value,
    }));
  if (!attributes) return null;

  const standardAttributes = attributes.filter(
    ({ key }) => !key.startsWith('_') &&
      !key.includes('item_') &&
      !key.includes('CGS'),
  );

  const gwpAttributes = attributes.filter(({ key }) =>
    key.startsWith('_gwp_message'),
  );

  const subscriptionAttribute = attributes.filter(
    ({ key }) => key === '_subscription',
  );

  const kitTitleAttributes = attributes.filter(({ key }) =>
    key.includes('CGS_title'),
  );

  const typeAttribute = attributes.find(({ key }) => key.startsWith('_type'));

  return (
    <>
      {typeAttribute && (
        <p className="utility-1 text-charcoal mb-2">{typeAttribute.value}</p>
      )}
      {kitTitleAttributes.length > 0 && (
        <ul className="mb-4 list-disc pl-5">
          {kitTitleAttributes.map(({ key, value }) => (
            <li
              className="utility-1 text-charcoal mb-1 order-1"
              key={`${key}:${value}`}
            >
              {value}
            </li>
          ))}
        </ul>
      )}
      {standardAttributes.length > 0 &&
        standardAttributes.map(({ key, value }) => (
          <>
            {value && (
              <p
                className={clsx('utility-1 mb-2 text-charcoal order-1')}
                key={`${key}:${value}`}
              >
                {clsx(key, ':', value)}
              </p>
            )}
          </>
        ))}
      {gwpAttributes.length > 0 &&
        gwpAttributes.map(({ key, value }) => (
          <p
            className={clsx('utility-1 mb-2 text-green order-2')}
            key={`${key}:${value}`}
          >
            {value}
          </p>
        ))}
      {subscriptionAttribute.length > 0 &&
        subscriptionAttribute.map(({ key, value }) => (
          <p
            className="utility-1 mb-2 text-charcoal order-1"
            key={`${key}:${value}`}
          >
            {clsx('Subscription:', value)}
          </p>
        ))}
    </>
  );
};

export default CartLineAttributes;
